import React from 'react';
import { useTranslation } from 'react-i18next';

type ToggleProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

/** Kebab button for a row's action menu; same look as the Vendor Center row menu. */
const RowMenuToggle = React.forwardRef<HTMLButtonElement, ToggleProps>(({ className, onClick, ...rest }, ref) => {
  const { t } = useTranslation('scenes.customerCenter');
  return (
    <button
      ref={ref}
      type="button"
      className={`customer-center__kebab ${className ?? ''}`.trim()}
      aria-label={t('openActions')}
      title={t('openActions')}
      onClick={(event) => {
        event.preventDefault();
        onClick?.(event);
      }}
      {...rest}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
        <circle cx="8" cy="3" r="1.8" />
        <circle cx="8" cy="8" r="1.8" />
        <circle cx="8" cy="13" r="1.8" />
      </svg>
    </button>
  );
});

RowMenuToggle.displayName = 'RowMenuToggle';

export default RowMenuToggle;
